/**
 * Posição decomposta tipo × submercado (#34 PR-B) — fetch com filtros.
 * Refetch quando tipo/submercado mudam; nonce descarta response velha
 * (mesma disciplina F1 do Simulador — nunca dado de filtro antigo na tela).
 */
import { useEffect, useRef, useState } from "react";
import { getPosicaoDecomposta } from "../api/client";
import type { PosicaoDecompostaResponse } from "../api/types";

export function usePosicaoDecomposta(tipo: string | null, submercado: string | null) {
  const [data, setData] = useState<PosicaoDecompostaResponse | null>(null);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const nonce = useRef(0);

  useEffect(() => {
    const meu = ++nonce.current;
    setLoading(true);
    setError(null);
    getPosicaoDecomposta({
      tipo: tipo ?? undefined,
      submercado: submercado ?? undefined,
    })
      .then((r) => {
        if (nonce.current !== meu) return;
        setData(r);
        setLoading(false);
      })
      .catch((e) => {
        if (nonce.current !== meu) return;
        setError(String(e));
        setLoading(false);
      });
  }, [tipo, submercado]);

  return { data, isLoading, error };
}
